module.exports = __webpack_public_path__ + "static/chatham-kent-health-team-logo-b3445bbc114d809c10667740c7d5128e.png";